export default function notificationsReducer(state = {
  notifications: [],
  notification: {},
  pins: {},
  emailBody: '',
  smsBody: '',
  siteMessageBody: '',
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'DELETE_NOTIFICATION_PENDING':
    case 'GET_NOTIFICATIONS_LIST_PENDING':
    case 'GET_NOTIFICATION_PINS_PENDING':
    case 'GET_NOTIFICATION_PENDING': {
      return {
        ...state,
        pins: {},
        fetching: true,
        emailBody: '',
        smsBody: '',
        siteMessageBody: '',
        fetched: false
      }
    }
    case 'GET_NOTIFICATIONS_LIST_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        notifications: action.payLoad.data,
      }
    }
    case 'GET_NOTIFICATIONS_LIST_REJECTED':
    case 'GET_NOTIFICATIONS_PINS_REJECTED':
    case 'GET_NOTIFICATION_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      }
    }
    case 'GET_NOTIFICATION_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pins: action.payLoad.meta.pins,
        emailBody: action.payLoad.data.attributes["email_body"] || '',
        smsBody: action.payLoad.data.attributes["sms_body"] || '',
        siteMessageBody: action.payLoad.data.attributes["site_body"] || '',
      }
    }
    case 'GET_NOTIFICATION_PINS_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        pins: action.payLoad.meta.pins,
      }
    }
    case 'DELETE_NOTIFICATION_FULFILLED': {
      return {
        ...state,
        fetching: false,
        fetched: true,
        errors: {}
      }
    }
    case 'DELETE_NOTIFICATION_REJECTED': {
      return {
        ...state,
        errors: action.payLoad
      }
    }
    default:
  }

  return {...state};
}


// WEBPACK FOOTER //
// ./src/reducers/notificationsReducer.js